export default __webpack_public_path__ + "static/media/ministere.2f886543.png";